/// image dimension for games, image inside game should be  in specific proportion
/// image in background (all screen image) should be bigger.
export default {
  background: {
    width: 1720,
    height: 1080,
    saveOriginalFileType: false
  },
  inside: {
    width: 400,
    height: 250,
    saveOriginalFileType: true
  }
}
